<template>
	<div class="register">
		<!-- 入会协议-->
		<el-dialog class="dialogNotice" v-if="$store.state.isregister" title="入会须知" :visible.sync="$store.state.isregister" width="60%" v-cloak>
			<div class="notice-title test-1">
				<p>一、申请加入本会，必须具备下列条件：</p>
				<p>（一）自愿加入本会；</p>
				<p>（二）承认本会章程；</p>
				<p>（三）依法取得本市营业执照的房地产开发经营企业以及与本行业相关的企事业单位；</p>
				<p>（四）应持有工商营业执照等相关证件；</p>
				<p>二、会员入会的程序：</p>
				<p>（一）提交入会申请书；</p>
				<p>（二）由本会理事会授权秘书处审核同意，并发给同意吸收入会的有关证书。</p>
				<p>三、会员履行下列义务：</p>
				<p>（一）遵守本会的章程；</p>
				<p>（二）执行本会的决议；</p>
				<p>（三）维护本行业的合法权益；</p>
				<p>（四）完成本会交办的工作；</p>
				<p>（五）向本会反映情况，提供有关资料；</p>
				<p>（六）按规定缴纳会费；</p>
				<p>（七）法律、法规、规章以及本会章程规定的其他义务。</p>
				<p>四、本会会员不得利用其经营规模、市场份额等优势，限制其他会员在本会中发挥作用。</p>
				<p>五、会员退会应向本会递交书面函件，并交回会员有关证书。</p>
				<p>会员如在两年内无故不缴纳会费或不参加本会活动的，经理事会确认，视为自动退会。本会取消其会员资格。</p>
				<p>六、会员如有严重违反国家法律、法规、规章或本会章程的，经理事会三分之二以上与会者表决通过，取消其会员资格并公示。</p>
				<p>会员如对理事会取消会员资格决定不服，可提出申诉，由理事会作出答复，必要时提交会员大会审议后答复。</p>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="remove">取 消</el-button>
				<el-button @click="register">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { getCmsDicts } from '../axios/request';
export default {
	// eslint-disable-next-line vue/multi-word-component-names
	name: 'Register',
	data() {
		return {};
	},
	methods: {
		// 取消注册
		remove() {
			this.$store.commit('getRegister', false);
		},
		// 跳转注册
		async register() {
			window.location.href = process.env.VUE_APP_BASE_URL_API + '/nkyxf/nav/register';
			const res = await getCmsDicts({});
			if (res != null && res.code == 200) {
				for (const [key, value] of Object.entries(res.data)) {
					localStorage.setItem(key, JSON.stringify(value));
				}
			}
		},
	},
};
</script>

<style scoped>
:deep(.el-dialog) {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin: 0 !important;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	border-radius: 10px;
	overflow: hidden;
}

:deep(.el-dialog__header) {
	padding: 20px;
	width: 100%;
	text-align: center;
	font-weight: 600;
	background-color: #f2f2f2;
}

:deep(.el-dialog__body) {
	padding: 30px;
	width: 100%;
}

.notice-title {
	width: 100%;
	height: 60vh;
	font-size: 14px;
	line-height: 38px;
	text-align: left;
	overflow: hidden;
	overflow-y: scroll;
}

.notice-title p {
	margin-bottom: 12px;
	font-size: 1em;
	letter-spacing: 1px;
	line-height: 32px;
	word-break: break-word;
	overflow-wrap: break-word;
}

.test-1::-webkit-scrollbar {
	/*滚动条整体样式*/
	width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
	height: 1px;
}

.test-1::-webkit-scrollbar-thumb {
	/*滚动条里面小方块*/
	border-radius: 10px;
	box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
	background: var(--bg-color-4);
}

.test-1::-webkit-scrollbar-track {
	/*滚动条里面轨道*/
	box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
	border-radius: 10px;
	background: #f2f2f2;
}

.note-frame {
	width: 100%;
	border: none;
	height: 100%;
}
:deep(.el-dialog__footer) {
	padding: 0px 20px 20px;
	width: 100%;
}
.dialog-footer {
	display: inline-block;
	width: 100%;
	text-align: center;
}
.dialog-footer .el-button {
	width: 30%;
	background-color: var(--bg-color);
	border-color: var(--bg-color);
	color: #fff;
	-webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	-moz-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	-ms-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	-o-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.dialog-footer .el-button:hover {
	background-color: var(--bg-color-8);
	border: 1px solid var(--bg-color-8);
	color: var(--text-light-color);
}
.dialog-footer .el-button:first-child {
	margin-right: 12%;
	background-color: #fff;
	border: 1px solid #dcdfe6;
	color: #606266;
}
.dialog-footer .el-button:first-child:hover {
	background-color: var(--bg-color);
	color: var(--text-light-color);
}
</style>
